// Formatting helpers for the staff Billing area. Invoice amounts are stored
// in DOLLARS (not cents) — same convention as BillingTab/ReferralPayouts.
import dayjs from '../../../lib/day';

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const money = (amount) => usd.format(Number(amount || 0));

// Empty dates render as a plain hyphen (no em dashes in human-facing copy).
export const fmtDate = (d) => (d ? dayjs(d).format('MMM D, YYYY') : '-');

export const fmtDateTime = (d) =>
  d ? dayjs(d).format('MMM D, YYYY h:mm A') : '-';

export const daysOverdue = (dueDate) => {
  if (!dueDate) return 0;
  return dayjs().startOf('day').diff(dayjs(dueDate).startOf('day'), 'day');
};
